import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { type PL1Machine } from "@packsize/schemas/machines";

import { getPl1Machines } from "@/api/machines/pl1-api-v2";

import { type UseMachinesQueryOptions } from "../types";

import { PL1_MACHINES_QUERY_KEY } from "./query-keys";

const REFETCH_INTERVAL = 15 * 1000;

export const getPl1MachinesQuery = <TData = PL1Machine[], TError = Error>(
	options?: UseMachinesQueryOptions<TData, TError>,
) => ({
	queryKey: PL1_MACHINES_QUERY_KEY,
	queryFn: getPl1Machines,
	refetchInterval: REFETCH_INTERVAL,
	staleTime: 10 * 1000,
	...options,
});

export const usePl1Machines = (
	options?: UseMachinesQueryOptions<PL1Machine[], Error>,
): UseQueryResult<PL1Machine[], Error> => {
	return useQuery<PL1Machine[], Error>(getPl1MachinesQuery(options));
};
